import {useMemo} from "react";
import {ObjectFactory} from "@commons/types";

export function useFactory<T>(factory: ObjectFactory<T>, json: Partial<T>) {
    return useMemo(() => {
        return factory(json);
    }, [factory,json]);
}